<template>
  <button
    v-tooltip="tooltip"
    type="button"
    class="btn me-1"
    :class="[computedVariantClass, sizeClass, extraClass]"
    :title="title"
    :disabled="disabled"
    @click.stop="onClick"
  >
    <i class="bi" :class="icon"></i>
  </button>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";

const props = defineProps({
  title: { type: String, default: "" }, // necháme i title (fallback + native tooltip)
  tooltip: { type: String, default: "" }, // váš v-tooltip text
  icon: { type: String, required: true }, // např. "bi-pencil-fill"
  variant: {
    type: String,
    default: "secondary",
    validator: (v) =>
      ["primary", "secondary", "success", "danger", "warning", "info", "dark"].includes(v),
  },
  outline: { type: Boolean, default: true },
  size: {
    type: String,
    default: "md",
    validator: (v) => ["sm", "md", "lg"].includes(v),
  },
  disabled: { type: Boolean, default: false },
  extraClass: { type: [String, Array, Object], default: "" },
});

const emit = defineEmits(["click"]);

const computedVariantClass = computed(() => {
  const base = props.outline ? "btn-outline-" : "btn-";
  return `${base}${props.variant}`;
});

const sizeClass = computed(() => {
  if (props.size === "sm") return "btn-sm";
  if (props.size === "lg") return "btn-lg";
  return "";
});

const onClick = (e) => {
  if (props.disabled) return;
  emit("click", e);
};
</script>